<template>
  <div>
    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-item
        :label="currentTrack.titleConfig.label"
        v-if="currentTrack.titleConfig.label"
      >
        <template>
          <div style="text-align: left">
            <a-date-picker
              :locale="locale"
              placeholder="选择日期"
              v-model="defaultValueDate"
              :valueFormat="dateFormat"
              :format="monthFormat"
              style="width: 40%; margin-right: 10px"
              :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
              size="small"
              @change="changeDate"
            />
            <a-time-picker
              :minute-step="5"
              placeholder="选择时间"
              v-model="defaultValueTime"
              :format="showTime.format"
              size="small"
              style="width: 30%"
              @change="changeTime"
            />
          </div>
        </template>
      </a-form-item>
      <template v-if="currentTrack.fileConfig">
        <!-- selectedRows[0].boundType.code -->
        <template v-for="(config, index_conf) in currentTrack.fileConfig[boundType.code]">
          <a-form-item :label="config.msg" :key="index_conf">
            <template>
              <div>
                <BaseUpload
                  :file-list="config.files"
                  :max-file="9"
                  @change="(options) => uploadFiles(options, config)"
                  @remove="(file) => handleCancel(file, config.files)"
                  @preview="handlePreview"
                ></BaseUpload>
                <!-- <a-upload
                  accept="image/png, image/jpeg"
                  :customRequest="
                    (options) => {
                      uploadFiles(options, config);
                    }
                  "
                  list-type="picture-card"
                  :file-list="config.files"
                  :remove="
                    (file) => {
                      handleCancel(file, config.files);
                    }
                  "
                  @preview="handlePreview"
                  @change="change_upload"
                  :beforeUpload="beforeUpload"
                >
                  <div v-if="config.files.length < config.fileCount">
                    <a-icon type="plus" />
                    <div class="ant-upload-text" style="font-size: 12px; width: 300px">
                      {{ config.uploadHolder }}
                    </div>
                  </div>
                </a-upload> -->
                <a-modal
                  :visible="form.previewVisible"
                  :footer="null"
                  @cancel="form.previewVisible = false"
                >
                  <img alt="example" style="width: 100%" :src="form.previewImage" />
                </a-modal>
              </div>
            </template>
          </a-form-item>
        </template>
      </template>
      <!-- <template v-if="currentTrack.titleConfig.desc">
				<h3>{{ currentTrack.titleConfig.desc }}</h3>
			</template> -->
    </a-form>

    <div class="footer">
      <a-button key="back" @click="cancelFedDetail"> 收起 </a-button>
      <a-button key="submit" type="primary" @click="okSubmit" :loading="confirmLoading">
        保存
      </a-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { searchReqParam } from "../../utils/searchReqParam";
import { compressImg } from "../../utils/compressImg";
import {
  uploadSeals,
  trackFeedbackDetail,
  // feedbackContainerWeighing,
} from "../../api/business-dispatch";
import BaseUpload from "@/components/base-upload";

export default {
  name: "visible-feedback",
  components: {
    BaseUpload,
  },
  props: {
    visibleLocal: {
      type: Boolean,
      default: false,
    },
    selectedRows: {
      type: Array,
      default() {
        return [];
      },
    },
    currentTrack: {
      type: Object,
    },
  },
  data() {
    return {
      defaultValueDate: moment(),
      defaultValueTime: moment(),
      showTime: {
        format: "HH:mm",
        minuteStep: 5,
        defaultTime: moment(),
      },
      req: searchReqParam(),
      locale,
      visible: false,
      dateFormat: "YYYY-MM-DD",
      monthFormat: "YYYY-MM-DD",
      confirmLoading: false,
      form: {
        respDate: moment(),
        previewVisible: false,
        previewImage: "",
      },
    };
  },
  computed: {
    boundType() {
      if (this.selectedRows && this.selectedRows.length >= 1) {
        return this.selectedRows[0].boundType;
      }
      return {
        code: "null",
        msg: "无进出口信息",
      };
    },
  },
  watch: {
    visible() {
      // 关闭窗口的时候进行一些初始化操作
      if (!this.visible) {
        this.form.respDate = "";
        this.defaultValueTime = "";
        this.form.previewVisible = false;
        this.form.previewImage = "";
        if (this.currentTrack.fileConfig) {
          this.currentTrack.fileConfig[
            // this.selectedRows[0].boundType.code
            this.boundType.code
          ].forEach((config) => {
            config.files = [];
          });
        }
        this.$emit("close", "关闭");
      }
      // console.log(this.form);
    },
    currentTrack(v) {
      if (!v) {
        // this.$message.warning("数据初五");
        this.$emit("close", "关闭");
      }
      console.log("vvvvv");
      this.form.respDate = moment();
      this.defaultValueTime = moment();
    },
  },
  created() {},
  mounted() {
    // this.visible = this.visibleLocal;
    // this.form.respDate = moment().format("YYYY-MM-DD");
  },
  methods: {
    moment,
    cancelFedDetail() {
      this.$emit("close", "关闭");
    },
    // 移除箱号照片
    handleCancel(file, files) {
      console.log(file, files);
      let index = files.indexOf(file);
      console.log(index);
      files.splice(index, 1);
      console.log(files);
    },
    // 预览箱号
    async handlePreview(file) {
      // console.log("=====preview======", file);
      this.form.previewImage = file.url || file.preview;
      this.form.previewVisible = true;
    },
    // 上传之前压缩照片 是不是有重复
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        if (!file.type.includes("image")) {
          this.$message.warning("请上传图片");
          reject(new Error("请上传图片"));
          return;
        }
        // const newFile = await this.compressImg(file);
        // resolve(newFile);
        compressImg(file).then((res) => {
          console.log(res);
          resolve(res);
        });
      });
    },
    change_upload(options) {
      console.log(options);
    },
    // 请求 upload 接口生成箱号照片url
    uploadFiles(options, config) {
      // console.log(options, config);
      // 封装请求数据
      const param = new FormData();
      const meta = {
        code: config.fileType.substring(0, 15),
        client: "PC",
        tag: config.fileType,
        time: Date.now(),
      };
      const params = {
        bizType: config.fileType,
      };
      for (let key in meta) {
        param.append(`meta.${key}`, meta[key]);
      }
      for (let key in params) {
        param.append(`params.${key}`, params[key]);
      }
      param.append("params.files", options.file);
      uploadSeals(param).then((res) => {
        // console.log(JSON.parse(res.data));
        let result = JSON.parse(res.data);
        if (result.code == "0") {
          // 成功
          const imgItem = {
            uid: Date.now(), // 注意，这个uid一定不能少，否则上传失败
            name: options.file.name,
            status: "done",
            url: result.data.filePaths[0], // url 是展示在页面上的绝对链接
            imgUrl: result.data.filePaths[0], // imgUrl 是存到 db 里的相对链接
            // response: '{"status": "success"}',
          };
          config.files.push(imgItem);
        } else {
          // 失败提示信息
          this.$message.error(result.msg);
        }
      });
    },
    changeDate(date) {
      this.form.respDate = date;
      // console.log(this.form.respDate);
    },
    changeTime(time) {
      this.defaultValueTime = time;
      console.log(this.defaultValueTime);
    },
    // 确定提交反馈信息
    okSubmit() {
      let params = {};
      params.containerId = this.selectedRows[0].containerId;
      params.currentUserCompanyId = "";
      params.currentUserId = "";
      params.orderId = this.selectedRows[0].orderId;
      params.trackStatus = this.currentTrack.code;
      params.feedbackTime =
        moment(this.form.respDate).format("YYYY-MM-DD") +
        " " +
        moment(this.defaultValueTime).format("HH:mm");
      console.log(params.feedbackTime);
      if (this.form.respDate == "" || this.form.respDate == null) {
        this.$message.error("反馈日期不能为空");
        return;
      }
      if (this.defaultValueTime == "" || this.defaultValueTime == null) {
        this.$message.error("反馈日期不能为空");
        return;
      }
      // 还箱反馈不需要上传图片
      let files = [];
      let checkResult = {
        flag: true,
        msg: "",
      };
      if (this.currentTrack.fileConfig) {
        this.currentTrack.fileConfig[
          // this.selectedRows[0].boundType.code
          this.boundType.code
        ].forEach((config) => {
          // 运输节点反馈照片不做必选限制
          // if (config.files.length < 1) {
          // 	checkResult.flag = false;
          // 	checkResult.msg = config.msg + "不能为空";
          // }
          config.files.forEach((file) => {
            files.push({
              fileType: config.fileType,
              url: file.url,
            });
          });
        });
        params.files = files;
      }
      if (!checkResult.flag) {
        this.$message.error(checkResult.msg);
        return;
      }

      this.req.params = params;

      this.confirmLoading = true;
      // 调用接口
      trackFeedbackDetail(this.req).then((res) => {
        // console.log(JSON.parse(res.data));
        let result = JSON.parse(res.data);
        if (result.code == "0") {
          // 成功提示信息
          this.$message.success(result.msg);
          // 重置
          this.visible = false;
          this.form = {
            respDate: "",
            files: [],
            previewVisible: false,
            previewImage: "",
          };
          this.confirmLoading = false;
          // 通知父单元成功消息
          this.$emit("success", this.currentTrack, files);
        } else {
          // 失败提示信息
          this.$message.error(result.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.footer {
  text-align: right;

  > button {
    margin: 10px;
    width: 100px;
  }
}

/deep/.ant-form :first-child .ant-form-item-label > label::before {
  content: "*";
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
  color: red;
}
</style>
